import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "react-query";
import { api } from "services/api";
import { AddShiftData } from "types/SupportAgent";
import { axiosError, axiosSuccess, handleRequestError, handleRequestSuccess } from "utils/Request";

async function addSupportShift(data: AddShiftData) {
  const { data: response } = await api.post('/support/shifts', data).then(axiosSuccess).catch(axiosError);
  return response;
}

export function useAddSupportShift() {
  const queryClient = useQueryClient();

  return useMutation((data: AddShiftData) => addSupportShift(data), {
    onSuccess: () => {
      handleRequestSuccess('Agente adicionado ao plantão!');
      queryClient.invalidateQueries('support-shifts');
    },
    onError: (error: AxiosError) => {
      handleRequestError(error, 'Erro ao adicionar agente ao plantão. Tente novamente.');
    },
  });
}
